import { Link } from 'react-router-dom';
import Textarea from '../forms/textarea';
import React, { useContext, useRef, useState } from 'react';
import { BuildContext } from '../../Data/Context/buildData';
import { LanguageContext } from '../../Data/Context/languageContext';
import parse from 'html-react-parser';

const Notes = ({ classes, notes, setNotes, itemType, title }) => {
    const [note, showNote] = useState();
    const { buildDataFromDB, buildMode } = useContext(BuildContext);
    const notesDB = useRef();
    const { t } = useContext(LanguageContext);

    if (notes !== "") {
        notesDB.current = notes;
    }

    function addNote(note) {
        showNote(note)
    }

    if (buildMode === 'building') {
        return (
            note === itemType
                ?
                <Textarea setNotes={setNotes} note={itemType}> {title} notes</Textarea>
                :
                <div className='text-end noteBtn'>
                    <Link className='options' to="" onClick={() => addNote(itemType)}>{t("add_notes")} <i className="fa-solid fa-note-sticky"></i></Link>
                </div>
        )
    } else if (buildMode === 'viewing' && itemType !== 'title') {
        return (
            <>
                {buildDataFromDB && notes &&
                    <div className={`mx-3 ${classes}`}>
                        <p className="items-title"><i className="fa-solid fa-file-pen"></i> {title} {t("notes")}</p>
                        <div className="note-gradient p-2">
                            {parse(t(notes))}
                        </div>
                    </div>
                }
            </>
        )
    } else if (buildMode === 'editing') {
        return (
            <Textarea setNotes={setNotes} note={itemType} value={notes}> {title} {t("notes")}</Textarea>
        )
    }

    if (buildMode === 'viewing' && itemType === 'title') {
        return (
            <div className={`mx-2 ${classes}`}>
                <h2 className="title-underline-gradient position-relative">
                    {parse(t(notes))}
                </h2>
            </div>
        )
    }
}
export default Notes;